<div
  [class]="currentTheme"
  [class.transparent]="isTransparent"
  [class.small]="currentSize === 'small' && !currentIcon"
  [class.small-with-icon]="currentSize === 'small' && currentIcon"
  [class.square]="currentShape === 'square'"
  [class.revert]="isReverted"
>
  @if (currentIcon && currentIcon !== 'bullet') {
  <mat-icon [svgIcon]="currentIcon"></mat-icon>
  }
  <p [class.bullet]="currentIcon === 'bullet'">{{ currentText }}</p>
</div>
